/* eslint-disable node/no-deprecated-api */
import React from 'react'
import PropTypes from 'prop-types'
import {Table, Column, Cell} from 'components/Table'
import Checkbox from 'components/Checkbox'
import {connect} from 'react-redux'
import {
  fetchUtmMappings,
  removeUtmMappings
} from 'redux/modules/settings/actions'
import {getUtmMappings} from 'redux/modules/settings/selectors'
import {format as urlFormat, resolve as urlResolve} from 'url'
import * as _ from 'lodash'
import {channelTypes} from '@divvit/common-channels'
import ChannelTitle from 'components/ChannelTitle'
import ChannelGroupTitle from 'components/ChannelGroupTitle'

export class MappedView extends React.Component {
  static propTypes = {
    fetchUtmMappings: PropTypes.func,
    removeUtmMappings: PropTypes.func,
    utmMappings: PropTypes.array,
    isUtmMappingFetching: PropTypes.bool
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedMappings: []
    }
  }

  componentWillMount() {
    const {fetchUtmMappings} = this.props
    fetchUtmMappings()
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedMappings: []
    })
  }

  render() {
    return (
      <div className='mapped-view'>
        <div className='mapped-view_intro'>
          Below are the rules that were created.
          <i className='mapped-view_intro_desc'>
            If any mapping in this section get removed, it only could show up at
            Unmapped section for re-mapping if there were data which associate
            with it received during the last 02 months.
          </i>
        </div>
        {this.renderMappedRulesTable()}
      </div>
    )
  }

  renderMappedRulesTable() {
    const {utmMappings, isUtmMappingFetching} = this.props
    const {selectedMappings} = this.state
    const disabled = selectedMappings.length === 0
    return (
      <form className='mapped-view_edit-form' onSubmit={this.handleSubmit}>
        <Table
          data={utmMappings}
          loading={isUtmMappingFetching}
          empty='No mappings'
        >
          <Column
            header='Channel Type'
            grow
            cell={data => (
              <Cell>
                {channelTypes[data.channel.dv_chtype]?.label ||
                  data.channel.dv_chtype}
              </Cell>
            )}
          />
          <Column
            header='Channel Group'
            grow
            cell={data => (
              <Cell>
                <ChannelGroupTitle id={data.channel.dv_chgroup} />
              </Cell>
            )}
          />
          <Column
            header='Channel'
            grow
            cell={data => (
              <Cell>
                <ChannelTitle id={data.channel.dv_channel} iconSize='16px' />
              </Cell>
            )}
          />
          <Column
            header='Utm'
            grow
            cell={data => (
              <Cell>
                {data.mappings.map((mapping, index) => {
                  const key = data._id + index
                  const item = {key, _id: data._id, mapping, index}
                  return (
                    <div key={key} className='mapped-url'>
                      <span>
                        {urlResolve(
                          '',
                          urlFormat({
                            pathname: '',
                            query: mapping
                          }) || ''
                        )}
                      </span>
                      <Checkbox
                        checked={!!_.find(selectedMappings, {key})}
                        onChange={checked => this.onSelect(item, checked)}
                      />
                    </div>
                  )
                })}
              </Cell>
            )}
          />
        </Table>
        <div className='mapped-view_edit-form_button'>
          <button className='is-red' disabled={disabled} type='submit'>
            Remove Selected
          </button>
        </div>
      </form>
    )
  }

  onSelect = (data, checked) => {
    const {selectedMappings} = this.state
    const itemIndex = _.findIndex(selectedMappings, {key: data.key})
    const isSelected = itemIndex > -1

    if (checked) {
      this.setState({
        selectedMappings: !isSelected
          ? [...selectedMappings, data]
          : selectedMappings
      })
    } else if (isSelected) {
      this.setState({
        selectedMappings: [
          ...selectedMappings.splice(0, itemIndex),
          ...selectedMappings.slice(itemIndex + 1)
        ]
      })
    }
  }

  handleSubmit = evt => {
    evt.preventDefault()
    const {selectedMappings} = this.state
    const {removeUtmMappings} = this.props
    removeUtmMappings(selectedMappings)
  }
}

const mapStateToProps = state => ({
  utmMappings: getUtmMappings(state),
  isUtmMappingFetching: state.settings.isUtmMappingFetching
})

export default connect(mapStateToProps, {
  fetchUtmMappings,
  removeUtmMappings
})(MappedView)



// WEBPACK FOOTER //
// ./client/views/SettingsUtmMappingView/MappedView.js